import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';
import Carousel from 'react-material-ui-carousel';
import s from './IntroSectionMobile.css';

export default function IntroSectionMobile({ items }) {
  useStyles(s);
  const longestComment = items.reduce((a, b) => (a.text.length > b.text.length ? a : b));
  return (
    <section>
      <h2>ارزش‌های تپسی</h2>
      <Carousel autoPlay interval={20000} navButtonsAlwaysInvisible animation="slide">
        {items.map((item) => (
          <div>
            <picture>
              <source srcSet={item.webpImage} type="image/webp" />
              <source srcSet={item.jpgImage} type="image/jpg" />
              <img src={item.jpgImage} alt={item.alt} width="100%" />
            </picture>
            <h3 className={s.valueTitle}>{item.title}</h3>
            <div className={s.relativeContainer}>
              <p className={s.hiddenDescription}>{longestComment.text}</p>
              <p className={s.description}>{item.text}</p>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  );
}

IntroSectionMobile.propTypes = {
  items: PropTypes.array.isRequired,
};
